<ul class="nav flex-column admin-side-navigation">

  <li class="nav-item">
    <a class="nav-link" routerLink="dashboard">
      <fa-icon [icon]="faTachometerAlt"></fa-icon> {{'Dashboard' | translate}}
    </a>
  </li>

  <li class="nav-item">
    <a class="nav-link" routerLink="studentprofiles">
      <fa-icon [icon]="faUserGraduate"></fa-icon> {{'Student profiles' | translate}}
    </a>
  </li>

  <li class="nav-item" ngbDropdown *ngIf="canManageCompanies">
    <a class="nav-link dropdown-toggle cursor-pointer" ngbDropdownToggle>
      <fa-icon [icon]="faBuilding"></fa-icon> {{'Companies' | translate}}
    </a>
    <div ngbDropdownMenu>
      <a ngbDropdownItem routerLink="companies">
        {{'Companies' | translate}}
      </a>
      <a ngbDropdownItem routerLink="company-accounts">
        {{'Company accounts' | translate}}
      </a>
    </div>
  </li>

  <li class="nav-item">
    <a class="nav-link" routerLink="jobs">
      <fa-icon [icon]="faFileContract"></fa-icon> {{'Jobs' | translate}}
    </a>
  </li>

  <li class="nav-item">
    <a class="nav-link" routerLink="teacherprofiles">
      <fa-icon [icon]="faHospitalUser"></fa-icon> {{'Teacher profiles' | translate}}
    </a>
  </li>

  <li class="nav-item">
    <a class="nav-link" routerLink="pages">
      <fa-icon [icon]="faFile"></fa-icon> {{'Pages' | translate}}
    </a>
  </li>

  <li class="nav-item">
    <a class="nav-link" routerLink="blogposts">
     <fa-icon [icon]="faEdit"></fa-icon> {{'News' | translate}}
    </a>
  </li>

  <li class="nav-item">
    <a class="nav-link" routerLink="posts">
      <fa-icon [icon]="faEdit"></fa-icon> {{'Blogs' | translate}}
    </a>
  </li>

  <li class="nav-item">
    <a class="nav-link" routerLink="projects">
      <fa-icon [icon]="faProjectDiagram"></fa-icon> {{'Projects' | translate}}
    </a>
  </li>

  <li class="nav-item">
    <a class="nav-link" routerLink="meetdays">
      <fa-icon [icon]="faCalendar"></fa-icon> {{'Meet days' | translate}}
    </a>
  </li>

  <li class="nav-item">
    <a class="nav-link" routerLink="experiencedays">
      <fa-icon [icon]="faCalendar"></fa-icon> {{'Follow-up days' | translate}}
    </a>
  </li>

  <li class="nav-item">
    <a class="nav-link" routerLink="events">
      <fa-icon [icon]="faCalendar"></fa-icon> {{'Events' | translate}}
    </a>
  </li>

  <li class="nav-item">
    <a class="nav-link" routerLink="videos">
      <fa-icon [icon]="faVideo"></fa-icon> {{'Videos' | translate}}
    </a>
  </li>

  <li class="nav-item">
    <a class="nav-link" routerLink="externalpageschools">
      <fa-icon [icon]="faSchool"></fa-icon> {{'Schools' | translate}} ({{'Content' | translate}})
    </a>
  </li>

  <li class="nav-item">
    <a class="nav-link" routerLink="testimonials">
      <fa-icon [icon]="faQuoteLeft"></fa-icon> {{'Testimonials' | translate}}
    </a>
  </li>

  <li class="nav-item">
    <a class="nav-link" routerLink="fieldofinterest">
      <fa-icon [icon]="faLightbulb"></fa-icon> {{'Field of interest' | translate}}
    </a>
  </li>

  <li class="nav-item">
    <a class="nav-link" routerLink="tags">
      <fa-icon [icon]="faTags"></fa-icon> {{'Tags' | translate}}
    </a>
  </li>

  <li class="nav-item">
    <a class="nav-link" routerLink="schools">
      <fa-icon [icon]="faSchool"></fa-icon> {{'Schools' | translate}}
    </a>
  </li>

  <li class="nav-item" ngbDropdown>
    <a class="nav-link dropdown-toggle cursor-pointer" ngbDropdownToggle>
      <fa-icon [icon]="faGraduationCap"></fa-icon> {{'Education system' | translate}}
    </a>
    <div ngbDropdownMenu>
      <a ngbDropdownItem routerLink="educations">
        {{'Educations' | translate}}
      </a>
      <a ngbDropdownItem routerLink="educationlevels">
        {{'Education levels' | translate}}
      </a>
    </div>
  </li>

  <li class="nav-item">
    <a class="nav-link" routerLink="matchtest">
      <fa-icon [icon]="faQuestion"></fa-icon> {{'Match test' | translate}}
    </a>
  </li>

  <li class="nav-item">
    <a class="nav-link" routerLink="accounts">
      <fa-icon [icon]="faUsers"></fa-icon> {{'Accounts' | translate}}
    </a>
  </li>

  <li class="nav-item">
    <a class="nav-link" routerLink="tools">
      <fa-icon [icon]="faToolbox"></fa-icon> {{'Tools' | translate}}
    </a>
  </li>

</ul>
